export default __webpack_public_path__ + "static/media/pepicons-pencil--pen.68f8bbcd.svg";